export class SuplementoModel {
    nombre: string; 
    categoria: string; 
    marca: string; 
    porcion: string;
    unidad: string; 
    calorias: number; 
    carbohidratos: number;
    azucar: number;
    fibra: number;
    proteinas: number;
    grasaTotal: number;
    grasaSaturada: number;
    grasaMonoinsaturada: number;
    grasaPoliinsaturada: number;
    grasaTrans: number;
    colesterol: number;
    imagenProducto?: {
        nombre: string;
        url: string;
    };
    imagenEtiqueta?: {
        nombre: string;
        url: string;
    };
    informacion: string;
    propietario: string;
    activo: boolean; // bandera que sirve para aliminar elemento
    empresaId: string;
}

export const marcasSuplementos: string[] = [
    '43 Supplements',
    'Amazing Grass',
    'Birdman',
    'BPI Sports',
    'BSN',
    'Cellucor',
    'Dymatize',
    'EFX Sports',
    'Evogen',
    'Gaspari Nutrition',
    'GAT sport',
    'Genérica',
    'GNC',
    'Habits',
    'Herbalife',
    'Isopure',
    'Life',
    'MHP',
    'Mister Natural',
    'MuscleMeds',
    'Musclepharm',
    'Muscletech',
    'Nature es Best',
    'Nutrex',
    'Nutrition Labz',
    'Optimum Nutrition',
    'Pitbull Labs',
    'Protein Plus',
    'Pura Nutrition Labs',
    'Pure Protein',
    'Quest',
    'Redcon1',
    'RIX Slm',
    'Sin marca',
    'Sprout Living',
    'Universal Nutrition',
    'Valara',
];

export const categoriasSuplementos: string[] = [
    'Aminoácidos',
    'Carbohidratos',
    'Creatinas',
    'Ganadores de peso',
    'Multivitamínicos',
    'Otros suplementos',
    'Pre-entrenadores',
    'Proteínas',
    'Quemadores',
];

export const suplementosBase: any[] = [
    {
        'nombre': 'Colágeno',
        'desc': 'Tomar 1 sobre de 7 g de grenetina Knox o una porción equivalente de otra marca a cualquier hora del día.'
    },
    {
        'nombre': 'Creatina',
        'desc': '5 g por día de lunes a domingo, de preferencia después de entrenar en los días de entrenamiento y a la misma hora en el resto de los días.'
    },
    {
        'nombre': 'Cúrcuma',
        'desc': 'Tomar al menos 1.5 g por día (aprox. 1/2 cucharita) disuelta en medio vasito de agua, en un jugo o licuado. Agrega pimienta negra para aumentar su absorción. Se puede tomar a cualquier hora del día, pero para mejores resultados te recomiendo tomarla antes de dormir.'
    },
    {
        'nombre': 'GABA',
        'desc': 'Comienza con una dosis baja de alrededor de 100 a 200 mg por día 30 minutos antes de irte a dormir. Si la dosis baja no produce los efectos deseados, puedes incrementar gradualmente hasta 500 mg.'
    },
    {
        'nombre': 'Glucosamina',
        'desc': '1,500 mg al día, de preferencia a la misma hora. Puedes dividir en tres dosis de 500 mg cada una o tomar una sola dosis diaria de 1,500 mg. Es importante que seas consistente con su uso para tener resultados.'
    },
    {
        'nombre': 'Jengibre',
        'desc': 'Tomar de 1 a 3 g por día (aprox. de 1/3 a 1 cucharita) de jengibre en polvo. Dependiendo de la cantidad, puedes tomarlo en una o varias dosis durante el día.'
    },
    {
        'nombre': 'Magnesio',
        'desc': 'Tomar 400 mg por día de glicinato o citrato de magnesio. La dosis puede dividirse en varias tomas a lo largo del día o tomarse en una sola dosis.'
    },
    {
        'nombre': 'Niacinamida',
        'desc': ''
    },
    {
        'nombre': 'Omega 3',
        'desc': 'Tomar 2,000 mg de EPA y DHA combinados (los 2 tipos de omega 3 más comunes) por día. Es recomendable tomar los suplementos de omega-3 con una comida que contenga grasa para mejorar su absorción. Puedes dividir la dosis en 3 tomas a lo largo del día o tomarlo en una sola dosis.'
    },
    {
        'nombre': 'Triptófano',
        'desc': 'Comienza con una dosis baja de alrededor de 500 mg por día 30 minutos antes de irte a dormir. Si la dosis baja no produce los efectos deseados, puedes incrementar gradualmente hasta llegar a 2000 mg. Es importante tomar el triptófano a la misma hora todos los días para mantener niveles constantes en el cuerpo.'
    },
    {
        'nombre': 'Vitamina C',
        'desc': 'Tomar 1,000 mg por día. Para mejorar su absorción, se recomienda dividir la dosis total en 3 dosis pequeñas a lo largo del día y tomarlas con los alimentos. De ser posible, tomar vitamina C de liberación prolongada para mejorar aún más la absorción.'
    },
    {
        'nombre': 'Vitamina D',
        'desc': 'Tomar de 600 a 800 UI (15-20 mcg) por día, de preferencia con alimentos que contengan grasa para mejorar su absorción.'
    },
]
